import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Paginator, List } from "extranet-component-library";
import _ from "lodash";

import warning from '../assets/img/warning.svg';
import { useStores } from "../hooks/useStores";
import { parseDate } from "../utils/parsers";

interface Notice {
  creation_date: string;
  id: number;
  title: string;
  type: string;
}

interface NoticesProps {
  notifications: Notice[];
  allLines: Array<any>;
}

const Notices = ({ ...props }: NoticesProps) => {
  const { t } = useTranslation();
  const { notificationStore } = useStores();
  const { getNotification, getAvisoSICTMWS } = notificationStore;
  const [propertiesNotifications, setPropertiesNotifications] = useState({
    isOpen: -1,
    first: 0,
    page: 0,
    items: [] as Notice[][],
  });
  const rows = 5;

  useEffect(() => {
    setPropertiesNotifications({
      ...propertiesNotifications,
      items: _.chunk(props.notifications, rows),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.notifications && props.notifications.length]);

  const onPageChange = (info: any) => {
    setPropertiesNotifications({
      ...propertiesNotifications,
      first: info.first,
      page: info.page,
      isOpen: -1,
    });
  };

  const seeDetail = (index: number) => {
    setPropertiesNotifications({
      ...propertiesNotifications,
      isOpen: index,
    });
  };

  let data: Notice[] = propertiesNotifications.items[propertiesNotifications.page];
  if (data) {
    data = data.map((notice: Notice) => {
      const copy = { ...notice };
      copy.creation_date = parseDate(copy.creation_date, true)
      return copy;
    })
  }

  return (
    <div className="favs-table">
      <div className="title">{t("warnings")}</div>
      {props.notifications && props.notifications.length ? (
        <>
          <List
            icon={warning}
            items={data}
            open={propertiesNotifications.isOpen}
            allLines={props.allLines}
            translate={t}
            getDetails={{ getNotification, getAvisoSICTMWS }}
            onClickItem={(index: number) => seeDetail(index)}
          />
          <Paginator
            total={props.notifications.length}
            first={propertiesNotifications.first}
            rows={rows}
            onPageChange={(info: any) => onPageChange(info)}
          />
        </>
      ) : (
        <div data-testid="no-warnings" className="no-items">
          {t("no_items")}
        </div>
      )}
    </div>
  );
};

export default Notices;
